<template>
  <div class="mt-4">
    <div class="flex justify-between flex-wrap md:flex-nowrap items-end mb-6">
      <!-- acciones de impresion -->
      <div class="flex items-end flex-wrap gap-4">
        <div class="relative group">
          <button
            class="bg-blue-100 flex items-center justify-center w-9 h-9 rounded-md text-blue-600"
          >
            <font-awesome-icon icon="fa-solid fa-ellipsis" class="rotate-90" />
          </button>
          <ul
            class="absolute top-full left-0 bg-white rounded-md shadow-lg overflow-hidden transition-all duration-300 transform scale-0 group-hover:scale-100"
          >
            <button
              class="px-6 py-2 text-orange-500 flex items-center hover:bg-orange-50 whitespace-nowrap w-full"
              @click="exportPDF(registers)"
            >
              <font-awesome-icon icon="fa-solid fa-print" class="mr-2" />
              Exportar a PDF
            </button>
            <button
              class="px-6 py-2 text-green-500 flex items-center hover:bg-green-50 whitespace-nowrap w-full"
              @click="exportToExcel(registers)"
            >
              <font-awesome-icon icon="fa-solid fa-print" class="mr-2" />
              Exportar a excel
            </button>
          </ul>
        </div>

        <label class="block mt-3 md:mt-0 w-full md:w-auto">
          <span class="block text-gray-600 font-semibold mb-1 text-sm"
            >Fec. de inicio</span
          >
          <input
            type="date"
            class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500 resize-none"
            v-model="dateStart"
            @change="resetValuesAndGetData"
          />
        </label>
        <label class="block mt-3 md:mt-0 w-full md:w-auto">
          <span class="block text-gray-600 font-semibold mb-1 text-sm"
            >Fec. Término</span
          >
          <input
            type="date"
            class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500 resize-none"
            v-model="dateEnd"
            @change="resetValuesAndGetData"
          />
        </label>
      </div>
      <!-- componente para mfiltrar por estado de orden de compra -->
      <label class="block mt-3 md:mt-0 w-full md:w-auto">
        <span class="block text-gray-600 font-semibold mb-1"
          >Filtrar por estados</span
        >
        <select
          v-model="shoppingState"
          class="bg-white border py-2 text-sm px-3 text-gray-600 cursor-pointer rounded-lg mr-3 outline-none min-w-[140px] font-semibold w-full"
          @change="resetValuesAndGetData"
        >
          <option value="VIGENTE">VIGENTE</option>
          <option value="ANULADO">ANULADO</option>
          <option value="DEVOLUCION">DEVOLUCION</option>
        </select>
      </label>
    </div>
    <div class="rounded-lg overflow-hidden border">
      <!-- secction para filtar por limite de registro -->
      <div class="py-4 px-3 flex items-center justify-between">
        <select
          v-model="limitRegister"
          class="bg-white border py-2 text-sm px-3 text-gray-600 cursor-pointer rounded-lg mr-3 outline-none min-w-[140px] font-semibold"
          @change="resetValuesAndGetData"
        >
          <option value="10">10 Registros</option>
          <option value="25">25 Registros</option>
          <option value="50">50 Registros</option>
          <option value="100">100 Registros</option>
          <option value="500">500 Registros</option>
          <option value="1000">1000 Registros</option>
        </select>
        <div class="w-full">
          <label for="modules">
            <input
              type="text"
              class="py-2 px-2 text-sm bg-white border outline-none rounded-lg shadow-sm text-gray-600 w-full"
              placeholder="Buscar por fecha, razon social o n° de documento del proveedor..."
              v-model="search"
              @keydown.enter="resetValuesAndGetData"
            />
          </label>
        </div>
      </div>

      <!-- seccion de conteido de datos tablas
          1: Para poner una tabla responsiva añadir lo siguiente:
          1.1: class="resize-generate"
          1.2: ref="widthNav" 
          1.3: @resize="handleResize"
      -->
      <div
        class="w-full resize-x resize-generate"
        ref="widthNav"
        @resize="handleResize"
      >
        <div class="overflow-x-auto">
          <table class="table-auto w-full">
            <TableHead :headers="header" />
            <LoadingTables v-if="loading" :columns="15" />
            <tbody class="text-gray-500 text-left border-t-[1px]" v-else>
              <tr
                v-for="(register, i) in registers"
                :key="i"
                class="hover:bg-blue-500 transition-colors hover:text-white capitalize font-semibold odd:bg-white even:bg-slate-50"
                @click="selectRow($event)"
              >
                <td
                  class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap"
                >
                  {{ register.proveedor.razon_social }}
                </td>
                <td
                  class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap uppercase"
                >
                  {{ register.tipo_comprobante.descripcion }}
                </td>
                <td
                  class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap uppercase bg-blue-50 text-blue-500"
                >
                  {{ register.numero_comprobante }}
                </td>
                <td
                  class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap uppercase"
                >
                  {{ money() }} {{ format(register.igv) }}
                </td>
                <td
                  class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap"
                >
                  {{ money() }} {{ format(register.subtotal) }}
                </td>
                <td
                  class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap font-bold"
                >
                  {{ money() }} {{ format(register.total) }}
                </td>
                <td
                  class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap"
                >
                  {{
                    register.entidad_bancaria === null
                      ? "---"
                      : register.entidad_bancaria
                  }}
                </td>
                <td
                  class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap"
                >
                  {{
                    register.numero_de_operacion === null
                      ? "---"
                      : register.numero_de_operacion
                  }}
                </td>
                <td
                  class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap"
                >
                  {{ formatDateTime(register.fecha_de_compra) }}
                </td>
                <td
                  class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap"
                >
                  <span
                    class="px-3 py-1 rounded-lg text-sm"
                    :class="{
                      'bg-orange-50 text-orange-600':
                        parseInt(register.descuento_aplicado) > 0,
                    }"
                  >
                    {{ register.descuento_aplicado }} %
                  </span>
                </td>
                <td
                  class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap"
                >
                  <span
                    class="px-3 py-1 rounded-lg"
                    :class="{
                      'bg-green-50 text-green-600':
                        parseFloat(register.monto_nota_de_debito) >= 1,
                    }"
                  >
                    {{
                      parseFloat(register.monto_nota_de_debito) >= 1
                        ? "Si"
                        : "No"
                    }}
                  </span>
                </td>
                <td
                  class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap"
                >
                  <span
                    class="px-3 py-1 rounded-lg"
                    :class="{
                      'bg-gray-50 text-gray-600':
                        register.tipo_de_venta.descripcion === 'CONTADO',
                      'bg-orange-50 text-orange-600':
                        register.tipo_de_venta.descripcion === 'CREDITO',
                    }"
                  >
                    {{ register.tipo_de_venta.descripcion }}
                  </span>
                </td>
                <td
                  class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap"
                >
                  <span class="px-3 py-1 rounded-lg bg-blue-50 text-blue-600">
                    {{ register.tipo_de_pago.descripcion }}
                  </span>
                </td>
                <td
                  class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap"
                >
                  <span
                    class="px-3 py-1 rounded-lg"
                    :class="{
                      'bg-green-50 text-green-600':
                        register.estado === 'VIGENTE',
                      'bg-orange-50 text-orange-600':
                        register.estado === 'ANULADO',
                      'bg-red-50 text-red-600': register.estado === 'DEVUELTO',
                    }"
                  >
                    {{ register.estado }}
                  </span>
                </td>
                <td
                  class="border-slate-200 text-sm px-6 py-2 text-right whitespace-nowrap flex justify-end"
                >
                  <div class="relative group">
                    <button
                      class="bg-blue-50 flex items-center justify-center w-8 h-8 rounded-md text-blue-500"
                    >
                      <font-awesome-icon icon="fa-solid fa-list-ul" />
                    </button>
                    <ul
                      class="absolute top-full right-0 bg-white rounded-md shadow-xl shadow-blue-300 border-blue-50 border-2 overflow-hidden transition-all duration-300 transform scale-0 group-hover:scale-100 z-50"
                    >
                      <button
                        class="px-6 py-2 text-blue-500 flex items-center hover:bg-blue-50 whitespace-nowrap w-full"
                        @click="printOnA4(register.id)"
                      >
                        <font-awesome-icon
                          icon="fa-solid fa-print"
                          class="mr-2"
                        />
                        Imprimir compra
                      </button>
                      <button
                        class="px-6 py-2 text-orange-500 flex items-center hover:bg-orange-50 whitespace-nowrap w-full"
                        @click="
                          cancelShopping(
                            register.id,
                            register.tipo_de_venta.descripcion === 'CONTADO'
                              ? 1
                              : 2,
                            register.proveedor.razon_social
                          )
                        "
                        v-if="
                          register.estado === 'VIGENTE' && canYouCancelShopping
                        "
                      >
                        <font-awesome-icon
                          icon="fa-solid fa-cancel"
                          class="mr-2"
                        />
                        Anular
                      </button>
                      <button
                        class="px-6 py-2 text-red-500 flex items-center hover:bg-red-50 whitespace-nowrap w-full"
                        @click="activeCreditNoteShopping(register.id)"
                        v-if="
                          register.estado === 'VIGENTE' && canYouModifiShopping
                        "
                      >
                        <font-awesome-icon
                          icon="fa-solid fa-truck"
                          class="mr-2"
                        />
                        Devolución de compra
                      </button>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <TablePagination
        :currentPage="currentPage"
        :total="totalPage"
        :next="next"
        :prev="prev"
      />
    </div>
  </div>

  <CreditNoteShopping
    :activeModal="activeCreditNoteShopping"
    :getdata="getData"
    :id="idShopping"
    v-if="stateRegisterCreditNoteShopping"
  />
</template>

<script>
import { onMounted, ref, watchEffect } from "vue";
import axios from "../../api";
import LoadingTables from "@/components/Loadings/LoadingTables";
import TableHead from "@/components/TablesComponents/TableHead";
import TablePagination from "@/components/TablesComponents/TablePagination.vue";
import CreditNoteShopping from "@/components/Shopping/CreditNoteShopping.vue";
import { errorActions, warningActions } from "@/alerts";
import { observer } from "@/observer";
import { idLocalStore, idLocalUser } from "@/publicjs/localStorage";
import { money, format } from "@/publicjs/money";
import { formatDateTime } from "@/publicjs/formatDate";
import { exportPDF } from "./Reports/PDFExportAllShopping";
import { exportToExcel } from "./Reports/ExcelExportAllShopping";
import { printOnA4 } from "./PrintVoucher/PrintOnA4";

import { cancelNow } from "@/repository/Shopping/CancelShopping";

import config from "/public/apis/config.json";
import { selectRow } from "@/publicjs/selectRowTable";
import { validateAccessSpecific } from "@/repository/Sales/ValidateAccessEspecific/ValidateAccess";

export default {
  name: "MainListShopping",
  components: {
    LoadingTables,
    TableHead,
    TablePagination,
    CreditNoteShopping,
  },
  setup() {
    // carga de datos a la tabla
    const registers = ref([]);
    const paginate = ["registers"];
    const loading = ref(true);
    const header = [
      [
        {
          title: "proveedor",
        },
        {
          title: "comprobante",
        },
        {
          title: "n° de comprobante",
        },
        {
          title: config.iva,
        },
        {
          title: "subtotal",
        },
        {
          title: "total",
        },
        {
          title: "entidad bancaria",
        },
        {
          title: "n° de operación",
        },
        {
          title: "fec. de compra",
        },
        {
          title: "descuento",
        },
        {
          title: "con N.C.",
        },
        {
          title: "T. de compra",
        },
        {
          title: "T. de pago",
        },
        {
          title: "estado",
        },
        {
          title: "Acciones",
        },
      ],
    ];
    const canYouModifiShopping = ref(false);
    const canYouCancelShopping = ref(false);
    const dateStart = ref("");
    const dateEnd = ref("");

    //variables de paginacion
    const currentPage = ref(1);
    const limitRegister = ref(10);
    const search = ref("");
    const resgisterPaginate = ref(null);
    const totalPage = ref(0);
    const idStore = ref(0); //ID de la sucursal
    const shoppingState = ref("VIGENTE");
    const getData = async () => {
      loading.value = true;
      const response = await axios
        .get(
          `compras/?page=${currentPage.value}&per_page=${limitRegister.value}&search=${search.value}&idstore=${idStore.value}&state=${shoppingState.value}&date_start=${dateStart.value}&date_end=${dateEnd.value}`
        )
        .catch((error) => errorActions(error));

      // validacion para mostrar una alerta cuando no se ha encontrado un registro
      if ((await response.data.data.length) === 0) {
        warningActions(
          "Los sentimos no pudimos encontrar lo que estabas buscando 😥"
        );
        //codigo para evitar el error de [resize observer]
        observer.observe(
          document.querySelector(".swal2-container"),
          { box: "content-box" },
          10
        );
      }
      registers.value = await response.data.data;
      resgisterPaginate.value = await response.data;
      totalPage.value = resgisterPaginate.value.last_page;
      loading.value = false;
    };

    //funcion para recetear valores
    const resetValuesAndGetData = async () => {
      currentPage.value = 1;
      await getData();
    };

    //calcular el ancho del nav y hacer el scroll en x de la tabla
    const widthNav = ref(null);
    const handleResize = () => {
      const nav = document.querySelector("nav").offsetWidth;
      watchEffect(() => {
        if (widthNav.value) {
          widthNav.value.style.width = `calc(100vw - ${nav + 42}px)`;
        }
      });
    };

    onMounted(async () => {
      handleResize();
      window.addEventListener("resize", handleResize);
      idStore.value = await idLocalStore();

      const ACCESS = ["GENERAR NOTA DE CREDITO COMPRAS", "ANULAR COMPRAS"];

      const validate = await validateAccessSpecific(
        ACCESS,
        await idLocalUser()
      );

      if (validate.includes("GENERAR NOTA DE CREDITO COMPRAS")) {
        canYouModifiShopping.value = true;
      }
      if (validate.includes("ANULAR COMPRAS")) {
        canYouCancelShopping.value = true;
      }
      await getData();
    });

    //! Funciones para avanzar y retrocedeer en la paginaciones
    const next = async () => {
      totalPage.value = resgisterPaginate.value.last_page;
      if (currentPage.value <= totalPage.value - 1) currentPage.value++;
      await getData();
    };
    const prev = async () => {
      totalPage.value = resgisterPaginate.value.last_page;
      if (currentPage.value >= 2) currentPage.value--;
      await getData();
    };

    //activar modal de registro y de actualizacion de datos
    const stateRegisterCreditNoteShopping = ref(false);
    const idShopping = ref(false);
    const activeCreditNoteShopping = (id) => {
      idShopping.value = id;
      stateRegisterCreditNoteShopping.value =
        !stateRegisterCreditNoteShopping.value;
    };

    //Llamada de funcion para anular la venta esta funcion biene desde el repositorio
    const cancelShopping = async (id, typeShopping, msg) => {
      await cancelNow(id, typeShopping, msg, resetValuesAndGetData);
    };

    return {
      loading,
      getData,
      paginate,
      header,
      registers,
      limitRegister,
      currentPage,
      search,
      next,
      prev,
      totalPage,
      resetValuesAndGetData,
      activeCreditNoteShopping,
      stateRegisterCreditNoteShopping,
      idShopping,
      widthNav,
      handleResize,
      shoppingState,
      money,
      format,
      formatDateTime,
      exportPDF,
      exportToExcel,
      printOnA4,
      cancelShopping,
      canYouModifiShopping,
      canYouCancelShopping,
      selectRow,
      dateStart,
      dateEnd,
    };
  },
};
</script>

<style scoped>
.active button svg {
  rotate: 90deg;
}
</style>
